import { getZPLCommandWithDefaultTemplate } from "./getZplCommandWithDefaultTemplate";

export default getZPLCommandWithDefaultTemplate;
